export type GenericStoreStatus = 'pending' | 'loading' | 'success' | 'error';

export interface GenericState<T> {
  appId?: string | null;
  data?: T | null;
  status: GenericStoreStatus;
  error: string | null;
}
